import './Survey.css';
import React, {useEffect} from 'react'
import { firestore } from "../firebase";

function Survey ({number, fireBaseDocId}){
  var colors;
  if(number === 2){
    colors = ["#afeeee", "#f8f8ff"]
  }
  else
    colors = GetColors();
  return (
      <div className='MainPage'>
          <Question number = {number}></Question>
          <Color color={colors[0]}/>{' '}<Color color={colors[1]}/>
          <br/>
          <ChechkList number = {number} 
                      colors={colors}
                      fireBaseDocId = {fireBaseDocId}/>
          <br/>
          <br/>
      </div>
  );
}

class ChechkList extends React.Component{
  render() {
    return(
        <div className='CheckListContainer'>
          <div className='HangMock'>No difference, same color</div>
          <CB number = {this.props.number} colors={this.props.colors} fireBaseDocId = {this.props.fireBaseDocId}/>
          <div className='HangMock'>100% totally different colors</div>
        </div>
    )
  }
}

function saveResult(fireBaseDocId, answer, colors, number){
  //save
  const bucket = firestore.collection("1");
  var idx1 = number + '.colors';
  var idx2 = number + '.answer';
  var something = {};
  something[idx1] = colors;
  something[idx2] = answer;
    bucket.doc(fireBaseDocId).update(something)
}

class CB extends React.Component{
  render(){
    this.defaultProps = {
      checked: false
    }
    const checkOnlyOne = (checkThis) => {
      //save
      saveResult(this.props.fireBaseDocId, checkThis.id, this.props.colors, this.props.number)
      
      //인풋관리
      const checkboxes = document.getElementsByName('checkBox' + this.props.number)
      for (let i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i] !== checkThis) {
          checkboxes[i].checked = false
        }
      }
    }
    return(
      <>
        <div className='CheckBox'>
          <div className='Scale'>0</div>
          <input type="checkBox" name={'checkBox' + this.props.number} id={0} checked={this.checked} onChange={(e) => checkOnlyOne(e.target)}/>
        </div>
        <div className='CheckBox'>
          <div className='Scale'>1</div>
          <input type="checkBox" name={'checkBox' + this.props.number} id={1} checked={this.checked} onChange={(e) => checkOnlyOne(e.target)}/>
        </div>
        <div className='CheckBox'>          
          <div className='Scale'>2</div>
          <input type="checkBox" name={'checkBox' + this.props.number} id={2} checked={this.checked} onChange={(e) => checkOnlyOne(e.target)}/>
        </div>
        <div className='CheckBox'>
          <div className='Scale'>3</div>
          <input type="checkBox" name={'checkBox' + this.props.number} id={3} checked={this.checked} onChange={(e) => checkOnlyOne(e.target)}/>
        </div>
        <div className='CheckBox'>
          <div className='Scale'>4</div>
          <input type="checkBox" name={'checkBox' + this.props.number} id={4} checked={this.checked} onChange={(e) => checkOnlyOne(e.target)}/>
        </div>
        <div className='CheckBox'>
          <div className='Scale'>5</div>
          <input type="checkBox" name={'checkBox' + this.props.number} id={5} checked={this.checked}  onChange={(e) => checkOnlyOne(e.target)}/>
        </div>
      </>
    )
  }

}


class Question extends React.Component{
  render() {
    return(
      <>
        <h2>Question {this.props.number}</h2>
      </>
    )
}
}

class Color extends React.Component{
  constructor(props){
    super(props);
  }
  render(){
    const style ={
      width:"100px",
      height:"100px",
      'backgroundColor':this.props.color,
      display:"inline-block"
    };
    
    return(
        <div style ={style}>
      </div>
    )
  }  
}

function GetColors(){
  let hex1 = "#ffffff";
  let hex2 = "#000000";

  while(hexDistance(hex1, hex2)>80){
    let minH1S1L1 = 0;
    let maxH1 = 360;
    let maxS1L1 = 256;

    let H1 = parseInt(minH1S1L1 + Math.random() * (maxH1 - minH1S1L1));
    let S1 = parseInt(minH1S1L1 + Math.random() * (maxS1L1 - minH1S1L1));
    let L1 = parseInt(minH1S1L1 + Math.random() * (maxS1L1 - minH1S1L1));
    let s_var = 15;
    let h_var = 20;
    let l_var = 30;
    let s_alpha = 2;
    let s_beta = 3;
    let h_alpha = 2.5;
    let h_beta = 5;

    let H2 = parseInt(minH1S1L1 + Math.random() * (maxH1 - minH1S1L1));
    let S2 = parseInt(minH1S1L1 + Math.random() * (maxS1L1 - minH1S1L1));
    let L2 = parseInt(minH1S1L1 + Math.random() * (maxS1L1 - minH1S1L1));
    let avg = (L1+L2)/2
    s_var = parseInt(s_var + (s_var*s_alpha - s_var) * ((2 * Math.abs(avg-127.5)/255) ** s_beta))
    h_var = parseInt(h_var + (h_var*h_alpha - h_var) * ((2 * Math.abs(avg-127.5)/255) ** h_beta))

    //두번째 색상
    let minS2 = Math.max(S1-s_var, 0);
    let minL2 = Math.max(L1-l_var, 0);
    let maxS2 = Math.min(S1+s_var, 255);
    let maxL2 = Math.min(L1+l_var, 255);

    let rand_num = Math.random() * h_var;
    H2 = parseInt(Math.max(H1 - h_var/2 + rand_num, 0));
    S2 = parseInt(Math.max(minS2 + Math.random() *(maxS2 - minS2), 0));
    L2 = parseInt(Math.max(minL2 + Math.random() *(maxL2 - minL2), 0));
    
    S1 = S1 / 255
    S2 = S2 / 255
    L1 = L1 / 255
    L2 = L2 / 255
    S1 = S1 * 100
    S2 = S2 * 100
    L1 = L1 * 100
    L2 = L2 * 100

    hex1 = hslToHex(H1,S1,L1)
    hex2 = hslToHex(H2,S2,L2)
  }
  console.log(hex1);
  console.log(hexDistance(hex1, hex2));
  return [hex1, hex2];
}

function hslToHex(h, s, l) {
  l /= 100;
  let a = s * Math.min(l, 1 - l) / 100;
  const f = n => {
      let k = (n + h / 30) % 12;
      let color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(255 * color).toString(16).padStart(2, '0');   // convert to Hex and prefix "0" if needed
  };
  return `#${f(0)}${f(8)}${f(4)}`;
}

function hexDistance(hex1, hex2) {
  let R1 = parseInt(hex1.substr(1, 2), 16);
  let G1 = parseInt(hex1.substr(3, 2), 16);
  let B1 = parseInt(hex1.substr(5, 2), 16);
  console.log(R1 +" "+ G1+" "+ B1)

  let R2 = parseInt(hex2.substr(1, 2), 16);
  let G2 = parseInt(hex2.substr(3, 2), 16);
  let B2 = parseInt(hex2.substr(5, 2), 16);
  console.log(R2 +" "+ G2+" "+ B2)

  let distance = Math.sqrt((R1-R2)**2 + (G1-G2)**2 + (B1-B2)**2)
  return distance;
}


export default Survey;
